import ExpanseResume from "../ExpanseResume";
import ExpansesList from "../ExpansesList";

const ExpansesView = () => {
  return (
    <>
      <ExpansesList />

      <ExpanseResume />
    </>
  );
};

export default ExpansesView;
